module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pages.changelog')))]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, [_c('ul', {
    staticClass: "nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.selecteds == 1
    },
    on: {
      "click": function($event) {
        _vm.showlistclick(1)
      }
    }
  }, [_c('span', [_vm._v("Backend")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.selecteds == 2
    },
    on: {
      "click": function($event) {
        _vm.showlistclick(2)
      }
    }
  }, [_c('span', [_vm._v("Frontend")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-contents",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('table', {
    staticClass: "datatable"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_c('td', [_vm._v(_vm._s(log.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.by_user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.text))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": log.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(log.link))])])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Дата")]), _vm._v(" "), _c('th', [_vm._v("Кто сделал")]), _vm._v(" "), _c('th', [_vm._v("Текст")]), _vm._v(" "), _c('th', [_vm._v("Ссылка")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cca61ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/ChangeLog.vue
// module id = 513
// module chunks = 0